export enum OS {
  APPLE_IOS = 'apple-ios',
  ANDROID = 'android',
  APPLE_MACOS = 'apple-macos',
  MICROSOFT_WINDOWS = 'microsoft-windows',
  CHROME_OS = 'chrome-os',
  LINUX = 'linux',
  WINDOWS_PHONE = 'windows-phone',
  WINDOWS_RT = 'windows-rt',
  UNKNOWN = '_unknown_',
}

export enum OS_LABEL {
  APPLE_IOS = 'Apple iOS',
  ANDROID = 'Android',
  APPLE_MACOS = 'Apple macOS',
  MICROSOFT_WINDOWS = 'Microsoft Windows',
  CHROME_OS = 'Chrome OS',
  LINUX = 'Linux',
  WINDOWS_PHONE = 'Windows Phone',
  WINDOWS_RT = 'Windows RT',
}
